<template>
  <div v-loading="isLoading" class="launch">
    <img style="margin-top: -100px;" class="logo" alt="logo" src="../../assets/logo.png" />
    <el-form style="width: 300px; margin-top: 40px;">
      <el-form-item label="帳號">
        <el-input type="text" v-model="form.username"></el-input>
      </el-form-item>
      <el-form-item label="密碼">
        <el-input @keyup.enter.native="submit" type="password" v-model="form.password"></el-input>
      </el-form-item>
      <el-button type="primary" @click="submit">登入</el-button>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoading: false,
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    goMain () {
      this.$router.push({ name: 'message-list' })
    },
    submit () {
      if (!this.validateInput()) return
      this.$services.auth.login(this, this.form).then(ok => {
        if (ok) {
          this.$services.fetchDatas(this).then(this.goMain)
        }
      })
    },
    validateInput () {
      var errMsg = null
      if (!this.form.username) {
        errMsg = '請輸入帳號'
      } else if (!this.form.password) {
        errMsg = '請輸入密碼'
      }
      if (errMsg != null) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {}
}
</script>

<style scoped>
.launch {
  width: 100%;
  height: 100%;
  background-color: antiquewhite;
  position: fixed;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo {
  width: 200px;
}
</style>
